/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Utils from "Utils";
export default {
  props: {
    placeholder: String,
    keywords: String
  },
  data: function data() {
    return {
      word: ''
    };
  },
  watch: {
    word: function word(val) {
      console.log(val);
    }
  },
  computed: {// word(){
    //   return ''
    //   // return this.keywords;
    // }
  },
  methods: {
    searchResult: function searchResult() {
      var keywords = this.word;
      this.$emit('search', keywords);
    }
  }
};